import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { DashboardComponent } from './dashboard.component';
import { SharedModule } from '../shared.module';
import { FormSharedModule } from '../form-shared.module';
import { RolWidgetsServices } from '../../_services/rol-widget.service';
import { UsuarioWidgetService } from '../../_services/usuario-widget.service';
import { WidgetUsuarioCargoComponent } from './widgets/usuarios-cargos/widget-usuario-cargo.component';
import { UsuariosService } from '../../_services/usuarios.service';
import { TerceroCargoService } from '../../_services/tercero-cargo.service';
import { NivelesService } from '../../_services/niveles.service';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { AgrupacionService } from '../../_services/agrupacion.service';
import { WidgetFiltroProspectoPerfilComponent } from './widgets/prospectos-perfiles/widget-filtro-prospecto-perfil.component';
import { WidgetProspectoPerfilActividadComponent } from './widgets/prospectos-perfiles/widget-prospecto-perfil-actividad.component';
import { WidgetProspectoPerfilEjecutivoComponent } from './widgets/prospectos-perfiles/widget-prospecto-perfil-ejecutivo.component';
import { WidgetProspectoPerfilMesComponent } from './widgets/prospectos-perfiles/widget-prospecto-perfil-mes.component';
import { TerceroZonaService } from '../../_services/tercero-zona.service';
import { ProspectoService } from '../../_services/prospecto.service';
import { SolicitudEstadoHistoricoService } from '../../_services/solicitud-estado-historico.service';
import { AgrupacionOficinaService } from '../../_services/agrupacion-oficina.service';
import { PlantillaService } from '../../_services/plantilla.service';
import {SolicitudService} from '../../_services/solicitud.service';
import {ComunicationComponentsService} from '../../_services/comunication-components.service';
import {ConfirmationService, MessageService} from 'primeng/api';
import { WidgetIntegracionesShivamComponent } from './widgets/integraciones-chivan/widget-integraciones-shivam.component';
import {DialogService} from 'primeng/dynamicdialog';
import {CambioEstadosComponent} from '../cambio-estados/cambio-estados.component';
import {EstadoService} from '../../_services/estado.service';
import {ProductoEstadoRelacionCausalService} from '../../_services/producto-estado-relacion-causal.service';
import {ConstanteService} from '../../_services/constante.service';
import {ProductoEstadoRelacionService} from '../../_services/producto-estado-relacion.service';
import {EstadoCausalService} from '../../_services/estado-causal.service';
import { WidgetAprobacionSolicitudesComponent } from './widgets/aprobacion-solicitudes/widget-aprobacion-solicitudes/widget-aprobacion-solicitudes.component';
import {PlataformaDigitalService} from '../../_services/plataforma-digital.service';
import {ProductoEstadoRelacionRolService} from '../../_services/producto-estado-relacion-rol.service';
import { FondoGarantiaComponent } from './widgets/fondo-garantia/fondo-garantia.component';
import {SolicitudOfertaGarantiaService} from '../../_services/solicitud-oferta-garantia.service';
import { WidgetSimuladorCreditoComponent } from './widgets/simulador-credito/widget-simulador-credito/widget-simulador-credito.component';
import { WidgetPerfilCrecamosComponent } from './widgets/perfil-crezcamos/widget-perfil-crezcamos.component';
import { AplModule } from '../../APL/apl.module';
import {WidgetSolicitudAhorroPendienteComponent} from './widgets/solicitud-ahorro-pendiente/widget-solicitud-ahorro-pendiente.component';
import {
    WidgetSolicitudInversionPendienteComponent
} from './widgets/solicitud-inversion-pendiente/widget-solicitud-inversion-pendiente.component';
import { WidgetTershiComponent } from './widgets/tershi/widget-tershi/widget-tershi.component';
import { WidgetAnulacionPagareComponent } from './widgets/pendientes-anulacion-pagare/widget-anulacion-pagare.component';
import {WidgetSincronizacionOfflineComponent} from './widgets/sincronizacion-offline/widget-sincronizacion-offline.component';

@NgModule( {
  declarations: [
    DashboardComponent,
    WidgetUsuarioCargoComponent,
    WidgetFiltroProspectoPerfilComponent,
    WidgetProspectoPerfilActividadComponent,
    WidgetProspectoPerfilEjecutivoComponent,
    WidgetProspectoPerfilMesComponent,
    WidgetIntegracionesShivamComponent,
    WidgetAprobacionSolicitudesComponent,
    FondoGarantiaComponent,
    WidgetSimuladorCreditoComponent,
    WidgetPerfilCrecamosComponent,
    WidgetSolicitudAhorroPendienteComponent,
    WidgetSolicitudInversionPendienteComponent,
    WidgetTershiComponent,
    WidgetAnulacionPagareComponent,
    WidgetSincronizacionOfflineComponent
  ],
  imports: [SharedModule, FormSharedModule, AplModule],
  providers: [
    RolWidgetsServices,
    UsuarioWidgetService,
    UsuariosService,
    NivelesService,
    EstructuraFisicaService,
    AgrupacionService,
    TerceroZonaService,
    TerceroCargoService,
    SolicitudEstadoHistoricoService,
    AgrupacionOficinaService,
    ProspectoService,
    PlantillaService,
    SolicitudService,
    MessageService,
    ComunicationComponentsService,
    DialogService,
    EstadoService,
    ProductoEstadoRelacionCausalService,
    ConstanteService,
    ConfirmationService,
    ProductoEstadoRelacionService,
    EstadoCausalService, PlataformaDigitalService, ProductoEstadoRelacionRolService,
    SolicitudOfertaGarantiaService
  ],
  exports: [DashboardComponent]
})

export class DashboardModule {

}
